export default __webpack_public_path__ + "static/media/Stripe.aa55a132.png";